class Store {
    constructor() {
        this.state ={
            fetchedItems: []
        };
    }
}

export default new Store()
